import React from 'react';
import { SearchEntity } from 'v2/models';
import { SearchResponseItemProps } from '../SearchResponseItem';
import { ResponsesListItemRenderer } from './components';
import { ResponsesListItem } from './types';

type ResponsesListProps = {
  responsesListItems: ResponsesListItem[];
  onAccepted: (request: SearchResponseItemProps) => void;
  request: SearchEntity;
};

export function ResponsesList({
  responsesListItems,
  onAccepted,
  request,
}: ResponsesListProps) {
  return (
    <>
      {responsesListItems.map((item, index) => (
        <ResponsesListItemRenderer
          key={index}
          responsesListItem={item}
          onAccepted={onAccepted}
          request={request}
        />
      ))}
    </>
  );
}
